<template>
  <div class="select-picker">
    <van-popup v-model="visible" position="bottom" :style="{ height: height }">
      <div class="select-box">
        <van-search
          placeholder="请输入客户姓名/编号"
          style="border-bottom:1px solid #f1f1f1;"
          class="search-box"
          v-model="keyword"
          @search="onSearch"
        />
        <data-list
          :api="getUserList"
          :params="listParams"
          style="height: calc(100vh - 66px); overflow: hidden;overflow-y: auto;"
        >
          <template v-slot:item="item">
            <van-cell
              center
              :title="item.Name"
              :value="item.TotalLimit"
              :label="item.Code"
              @click="handleSelect(item)"
            />
          </template>
        </data-list>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getUserList } from "@/api/user.js";
import DataList from "@/components/DataList";

import { Notify, Popup, Picker, Cell, CellGroup, Icon, Search } from "vant";
export default {
  name: "SelectMultiplePicker",
  components: {
    [Notify.name]: Notify,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [Search.name]: Search,
    DataList,
  },
  props: {
    height: {
      type: String,
      default: "100%",
    },

    change: { type: Function },
  },
  data() {
    return {
      getUserList,
      listParams: {},
      visible: false,
      keyword: "",
      checkedValue: [],
      checkedData: [],
    };
  },
  created: function() {},
  mounted() {
    this.visible = true;
  },

  methods: {
    onSearch() {
      this.listParams = {
        Keyword: this.keyword,
      };
    },
    cancel() {
      this.visible = false;
      this.$emit("destroy");
    },
    handleSelect(item) {
      if (item.TotalLimit == "0.00") {
        Notify("余额不足");
        return false;
      }
      this.$emit("change", item);
      this.visible = false;
      this.$emit("destroy");
    },
  },
};
</script>

<style lang="less" scoped>
.select-box {
  position: relative;
  height: 100vh;
  padding-top: 56px;
  .search-box {
    position: absolute;
    top: 0;
    width: 100%;
  }
}
</style>
